import React from 'react';

import './LoadingSpinner.sass';

const LoadingSpinner = ({ text, noShadow }) => {
  return (
    <div className={`loading-spinner-wrapper ${noShadow ? 'no-shadow' : ''}`}>
      <span className='loading-spinner'></span>
      <span>{ text }</span>
    </div>
  );
}

export default LoadingSpinner;
